const binding = { modules: {}, dataActions: {} };

    (binding.modules['trustpilot-widget'] = {
        c: () => require('partner/modules/trustpilot-widget/trustpilot-widget.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'trustpilot-widget',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/trustpilot-widget'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|trustpilot-widget|trustpilot-widget'] = {
                c: () => require('partner/modules/trustpilot-widget/trustpilot-widget.view.tsx'),
                cn: '__local__-__local__-trustpilot-widget'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };